import React, { Component } from "react";
import { PureComponent } from "react";
import config from "../../common/config";
import { Consume } from "../../Context/Consumer";
import { hasTeam, getIsLateOnboardUser, makeClasses } from "../../common";
import { LoginContext } from "../../Context/index";
import { isPlayerInTeam, getPlayerInteam } from "./helper";
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock";
import { get } from "jquery";
import PlayerImage from "../playerImage";

class Bio extends PureComponent {
  constructor(props) {
    super(props);
    // this.autoComplete.bind(this)
  }
  componentDidMount() {
    disableBodyScroll(document.querySelector("body"));
  }

  getPlayerName = (part, player) => {
    if (part == 1) {
      return player.pFName.split(" ")[0];
    } else {
      let playerNameSplit = player.pFName.split(" ");
      playerNameSplit.shift();
      return playerNameSplit.join(" ");
    }
  };

  closePopUp = () => {
    if (this.props.closeLiveScore) {
      this.props.closeLiveScore();
    } else {
      if (this.props.specificdata && this.props.specificdata.stopScoring) {
        this.props.specificdata.stopScoring(true);
      }
    }
    // this.props.setClosingAnimation();
    // setTimeout(() => {
    //     this.props.close();
    // }, 400)
    this.props.close();
  };

  render() {
    let player = this.props.player;
    let {
      config,
      trans,
      getTrans,
      rawMatchDay,
      gamedays,
      addHeaderclassName,
      teamData,
      showGeneric,
    } = this.props;
    /* let pStatusObj = config.statusIcons ? config.statusIcons : {};
    let isLateOnboarding = getIsLateOnboardUser(gamedays, rawMatchDay);

    let pStatus,
      playerText = "";
    let showWarningText = false;

    if (!hasTeam(this.props.loginData)) {
      if (player.teamPlayed) {
        showWarningText = true;
        pStatus = showGeneric ? "" : config.warningStatus;
      }
    } else {
      //check for raw details
      let isPlayInTeam = isPlayerInTeam(player.id, teamData);
      if (isPlayInTeam) {
        //get player from team for Db details
        let extractedPlayer = getPlayerInteam(player.id, teamData);
        if (extractedPlayer) {
          if (extractedPlayer.DBDetails && isLateOnboarding) {
            if (!extractedPlayer.DBDetails.isactive) {
              showWarningText = true;
              pStatus = showGeneric ? "" : config.warningStatus;
            }
          }
        }
      } else {
        if (player.teamPlayed && isLateOnboarding) {
          showWarningText = true;
          pStatus = showGeneric ? "" : config.warningStatus;
        }
      }
    }

    if (player.pStatus && pStatus != config.warningStatus) {
      pStatus = player.pStatus;
    }
    let UpcomingMd = rawMatchDay.mdId ? +rawMatchDay.mdId : "-";

    let pStatusHeaderClass = pStatusObj[pStatus]
      ? pStatusObj[pStatus].bioClass
      : "";
    let iconClass = pStatusObj[pStatus] ? pStatusObj[pStatus].class : "";
    playerText = pStatusObj[pStatus]
      ? getTrans(trans, pStatusObj[pStatus].text, pStatusObj[pStatus].text)
      : "";

    if (showWarningText) {
      if (showGeneric) {
      } else {
        playerText =
          getTrans(trans, "PlayerBioText", "Already played on Matchday") +
          " " +
          UpcomingMd;
      }
    }

    const playerImg =
      config.WebConfig.END_POINT_PLAYER_IMAGE +
      player.id +
      ".jpg?v=" +
      config.WebConfig.playerjerseyteamversion;
    const teamImg =
      config.WebConfig.END_POINT_TEAM_IMAGE +
      player.cCode +
      ".png?v=" +
      config.WebConfig.playerjerseyteamversion;

    if (!addHeaderclassName) {
      pStatusHeaderClass = "";
    } */
    let sClass = makeClasses({
      "si-card--red": player.DBDetails?.IsRedCard === 1,
      "si-card--yellow": player.DBDetails?.IsRedCard === 2,
      "si-injury":
        player.details.PlayerStatus === config.enumPlayerStatus.Injured,
      "si-suspended":
        player.details.PlayerStatus === config.enumPlayerStatus.Suspended,
      "si-doubtful":
        player.details.PlayerStatus === config.enumPlayerStatus.Doubtful,
    });
    return (
      <div className="si-player__header">
        <div
          className="si-popup__close"
          onClick={() => this.props.showHidePlyrCard()}
        >
          <div className="si-btn__adRe"></div>
        </div>
        <div className={"si-player__header-top " + sClass}>
          <div className="si-plyrSel__fBox">
            <PlayerImage
              playerId={player.details.Id}
              teamId={player.details.TeamId}
              removePointer={true}
            />
            <div className="si-plyrSel__fItem--rgt">
              <div className="si-plyrSel__name">
                <span>{player.details.DisplayName}</span>
                {/* <span>{player.details.PlayerFullName}</span> */}
              </div>
              <div className="si-plyrSel__skill">
                <span>
                  {getTrans(
                    trans,
                    config.positionMap[player.skill].singSkillTrans
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="si-player__header-bot">
          <ul>
            <li>
              <div className="si-player__stats-lbl">
                <span>{getTrans(trans, "selectedBy", "Selected by")}</span>
              </div>
              <div className="si-player__stats-num">
                <span>
                  {player.details.SelectedPercentage}
                  <em>%</em>
                </span>
              </div>
            </li>
            <li>
              <div className="si-player__stats-lbl">
                <span>{getTrans(trans, "totPoints", "Total Points")}</span>
              </div>
              <div className="si-player__stats-num">
                <span>
                  {player.details.Overallpoints}{" "}
                  <em>{getTrans(trans, "pts", "Pts")}</em>
                </span>
              </div>
            </li>
            <li>
              <div className="si-player__stats-lbl">
                <span>{getTrans(trans, "price", "Price")}</span>
              </div>
              <div className="si-player__stats-num">
                <span>
                  {Math.round(player.details.Value * 100) / 100}{" "}
                  {getTrans(trans, "AED", "AED")}
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
    /* return (
      <div className={"si-plyr__head si-bg--plyr-card " + pStatusHeaderClass}>
        <div className="si-bg--pattern"></div>
        <div className="si-plyr__left">
          <div
            className="si-plyr__thumbnail si-circle"
            style={{ backgroundImage: "url(" + playerImg + ")" }}
          >
            <div
              className="si-plyr__club"
              style={{ backgroundImage: "url(" + teamImg + ")" }}
            ></div>
          </div>
        </div>
        <div className="si-plyr__right">
          <div className="si-plyr__fname">{this.getPlayerName(1, player)}</div>
          <div className="si-plyr__lname">{this.getPlayerName(2, player)}</div>
          <div className="si-plyr__country">
            {player.tName} -{" "}
            {config.positionMap[player.skill]
              ? getTrans(
                  trans,
                  config.positionMap[player.skill].key,
                  config.positionMap[player.skill].key
                )
              : "-"}
          </div>
        </div>
        <div
          className="si-close"
          onClick={() => {
            this.closePopUp();
          }}
        ></div>
      </div>
    ); */
  }
}

export default Consume(Bio, [LoginContext]);
